// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
import '../scss/style.scss';
// import './header.js';
// import './modal.js';

// The WordPress entry bundle is versioned with filemtime. Run this same
// error-page correction here so its deployment always receives a fresh URL.
(() => {
    const fixErrorPageMenuLinks = () => {
        if (!document.body?.classList.contains('error404')) return;

        const isHcpContext = /^\/hcp(?:\/|$)/.test(window.location.pathname);
        const destinations = new Set([
            '#financial-assistance',
            '#nurse-educators',
            '#specialty-pharmacy'
        ]);

        if (!isHcpContext) {
            destinations.add('#provider-locator');
        }

        document.querySelectorAll('a[href^="#"]').forEach((link) => {
            const hash = link.getAttribute('href');

            if (destinations.has(hash)) {
                link.setAttribute('href', `${isHcpContext ? '/hcp/' : '/'}${hash}`);
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fixErrorPageMenuLinks);
    } else {
        fixErrorPageMenuLinks();
    }
})();

jQuery(document).ready(function($) {
    $('a[href*="#"]').off('click');
});

const hideOmnichannelChatWidget = () => {
    const selectors = [
        '#Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window',
        'iframe[name="Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window"]',
        'iframe[src*="livechatwidget"]',
        'iframe[src*="omnichannel"]',
        '#oc-lcw-chat-button',
        '#oc-lcw'
    ];

    document.querySelectorAll(selectors.join(', ')).forEach((element) => {
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('opacity', '0', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
    });
};

hideOmnichannelChatWidget();

const omnichannelObserver = new MutationObserver(() => {
    hideOmnichannelChatWidget();
});

const startOmnichannelObserver = () => {
    if (!document.body) {
        return;
    }

    omnichannelObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startOmnichannelObserver, { once: true });
} else {
    startOmnichannelObserver();
}

window.addEventListener('load', hideOmnichannelChatWidget);

// Function to check if we're in Divi Visual Builder
const isDiviVisualBuilder = () => {
    return (
        window.et_fb ||
        window.ET_Builder ||
        document.body.classList.contains('et-fb') ||
        document.body.classList.contains('et_fb') ||
        window.location.href.includes('et_fb=1') ||
        window.location.href.includes('et-bfb') ||
        typeof window.ET_Builder !== 'undefined'
    );
};

// Only load ISI script if not in Divi Visual Builder
if (!isDiviVisualBuilder()) {
    import('./header.js').then(() => {
        console.log('Header script loaded');
    }).catch(err => {
        console.warn('Failed to load Header script:', err);
    });

    import('./isi.js').then(() => {
        console.log('ISI script loaded');
    }).catch(err => {
        console.warn('Failed to load ISI script:', err);
    });

    import('./modal.js').then(() => {
        console.log('Modal script loaded');
    }).catch(err => {
        console.warn('Failed to load Modal script:', err);
    });
} else {
    console.log('Skipping ISI script in Divi Visual Builder');
}


console.log("Crinetics theme scripts initialized", "v1.0.0");
